import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";

import { copy } from "shared/assets";
import { addTemporaryToast } from "shared/components/Toast";
import {
  IAPIState,
  IInfoBlockItem,
  IInfoBlockItemType,
  IStatus,
} from "shared/types";
import { getInfoBlockItemReadableName } from "shared/utils";

export interface DeleteInfoBlockItemBaseProps {
  type: IInfoBlockItem;
  deleteItem: IInfoBlockItemType;
  handleClose: () => void;
}

interface DeleteInfoBlockItemHookProps
  extends Omit<DeleteInfoBlockItemBaseProps, "deleteItem"> {
  deleteItemApiStatus?: IAPIState;
}

export const useDeleteInfoBlockItem = ({
  type,
  handleClose,
  deleteItemApiStatus,
}: DeleteInfoBlockItemHookProps) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (deleteItemApiStatus === IAPIState.succeeded) {
      dispatch(
        addTemporaryToast({
          status: IStatus.success,
          message: copy.actions.deleted,
        })
      );
      handleClose();
    }
  }, [deleteItemApiStatus, dispatch, handleClose, type]);

  const itemReadbleName = useMemo(
    () => getInfoBlockItemReadableName(type),
    [type]
  );

  const extraDeleteMessage = useMemo(() => {
    if (type === IInfoBlockItem.contact || type === IInfoBlockItem.place) {
      return copy.deleteInfoBlockItem.message.replace("%s", itemReadbleName);
    }

    return null;
  }, [type, itemReadbleName]);

  return { itemReadbleName, extraDeleteMessage };
};
